import React from 'react'
import { SmartInput } from 'app/components/formik/Input'
import { Text } from 'app/components/ui/Text'
import { SmartCheckbox } from 'app/components/formik/Checkbox'
import { themeEstra } from 'app/styles/themeEstra'
import styled from 'styled-components'
import { FormSection } from 'app/components/shared/FormSection'
import { FormGroup } from 'app/components/shared/FormGroup'

export const Certifications: React.FC = () => {
  return (
    <>
      <FormSection>
        <FormGroup>
          <SmartInput
            label='Dichiaro di essere in possesso dell’abilitazione di cui al DM 37/08, art. 1'
            name='company_dm_letters'
            placeholder='Lettere'
          />
        </FormGroup>
        <FormGroup>
          <Text
            variant='s16'
            mb={0.5}
            color={themeEstra.color.primari.grigioEstra}
          >
            Dichiaro di aver conseguito/adottato un sistema di gestione
            aziendale conforme allo standard:
          </Text>
          <CheckboxesWrapper>
            <SmartCheckbox name='standard_iso_9001'>ISO 9001</SmartCheckbox>
            <SmartCheckbox name='standard_iso_14001'>ISO 14001</SmartCheckbox>
            <SmartCheckbox name='standard_ohsas18001'>Ohsas18001</SmartCheckbox>
            <SmartCheckbox name='standard_iso_45001'>ISO 45001</SmartCheckbox>
            <SmartCheckbox name='standard_iso_iec_27001'>
              ISO/IEC 27001
            </SmartCheckbox>
            <SmartCheckbox name='standard_sa8000'>SA8000</SmartCheckbox>
          </CheckboxesWrapper>
        </FormGroup>

        <FormGroup>
          <SmartInput
            label='Altre certificazioni di sistema / servizio / prodotto'
            name='standard_other'
          />
        </FormGroup>
      </FormSection>
    </>
  )
}

const CheckboxesWrapper = styled.div`
  display: flex;

  > * {
    padding-right: 4rem;
  }

  @media (max-width: ${({ theme }) => theme.bp.desktop}) {
    display: block;

    > * {
      padding-right: 0rem;
      padding-bottom: 1rem;
    }
  }
`
